<template>
  <div class="animated fadeIn">
    <Row>
      <Input clearable size="small" search @on-search="onFilterClick" v-model="keywordFilter" placeholder="名称/联系电话/联系地址" style="width: 200px; margin-right: 3px;"></Input>
      <Button size="small" type="primary" style=" margin-right: 3px;" @click="onFilterClick">查询</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div>
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onModifySuccess"></vehicle-info-detail-modal>
  </div>
</template>

<script>

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

import VehicleInfoDetailModal from '@/view/transport/components/vehicle-info-detail-modal'

function calRegistrationTextColor (colorid) {
  if (colorid === 1) {
    return '#ffffff'
  } else if (colorid === 2) {
    return '#ffffff'
  } else if (colorid === 3) {
    return '#ffffff'
  } else if (colorid === 4) {
    return '#000000'
  } else {
    return '#000000'
  }
}
function calRegistrationColor (colorid) {
  if (colorid === 1) {
    return '#2b85e4'
  } else if (colorid === 2) {
    return '#ff9900'
  } else if (colorid === 3) {
    return '#1c2438'
  } else if (colorid === 4) {
    return '#f8f8f9'
  } else {
    return '#bbbec4'
  }
}

export default {
  name: 'peccancyrecords',
  components: {
    VehicleInfoDetailModal
  },
  data () {
    return {

      onlineHandleFilter: [],
      handleSignFilter: [],

      vehicleOwnerInfoFilter: null,

      allVehicleOwnerInfos: [],

      // 车辆信息详细信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      processStateFilter: null,
      peccancyrecordTypeFilter: null,

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      totalElements: 0,
      content: [],
      pageSize: 30,
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '车牌',
          resizable: true,
          key: 'transportVehicleInfoId',
          ellipsis: 'true',
          width: 120,
          sortable: 'custom',
          render: function (h, params) {
            let registrationNum = params.row.transportVehicleInfo.registrationNum
            if (params.row.customName) {
              registrationNum = registrationNum + '(' + params.row.customName + ')'
            }
            return h('div', {
              props: {
                disabled: false
              },
              style: {
                'text-align': 'center',
                backgroundColor: calRegistrationColor(params.row.transportVehicleInfo.registrationColor),
                color: calRegistrationTextColor(params.row.transportVehicleInfo.registrationColor)
              },
              on: {
                click: () => {
                  // this.onRegistrationNOClick(params.row)
                }
              }
            }, registrationNum)
          }
        },
        {
          title: '车辆所有人',
          resizable: true,
          key: 'transportVehicleInfo.vehicleOwnerInfoId',
          sortable: 'custom',
          ellipsis: 'true',
          minWidth: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.vehicleOwnerInfoFilter = []
              val.forEach(item => {
                this.vehicleOwnerInfoFilter.push(genQueryParam('transportVehicleInfo.vehicleOwnerInfoId', 'EQ', item))
              })
            } else {
              this.vehicleOwnerInfoFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            if (params.row.transportVehicleInfo.vehicleOwnerInfo) {
              return h('label', params.row.transportVehicleInfo.vehicleOwnerInfo.shortName)
            }
          }
        },
        {
          title: '客户',
          resizable: true,
          key: 'transportVehicleInfo.clientInfoId',
          sortable: 'custom',
          ellipsis: 'true',
          minWidth: 180,
          render: (h, params) => {
            let display = []
            if (params.row.transportVehicleInfo.clientInfo) {
              display.push(h('div', params.row.transportVehicleInfo.clientInfo.name + '(' + params.row.transportVehicleInfo.clientInfo.phoneNum + ')'))
            } else {
              display.push(h('div', '无'))
            }
            return h('div', display)
          }
        },
        {
          title: '查询时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'analyzeDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.analyzeDatetime) {
              let d = new Date(params.row.analyzeDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '违章时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'peccancyDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.peccancyDatetime) {
              let d = new Date(params.row.peccancyDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '违章位置',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'address',
          width: 160
        },
        {
          title: '违章行为',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'action',
          width: 160
        },
        {
          title: '违章罚款',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'fine',
          width: 160
        },
        {
          title: '违章扣分',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'score',
          width: 160
        },
        {
          title: '违章城市',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'cityName',
          width: 160
        },
        {
          title: '采集机构',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'colorgan',
          width: 160
        },
        {
          title: '决定书编号',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'decisionNum',
          width: 160
        },
        {
          title: '监控编号',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'monitorNum',
          width: 160
        },
        {
          title: '处理标记',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'handleSign',
          width: 160,
          filters: [
            { label: '未处理未支付', value: 1 },
            { label: '已处理未支付', value: 2 },
            { label: '已处理已支付', value: 3 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.handleSignFilter = []
              val.forEach(item => {
                this.handleSignFilter.push(genQueryParam('handleSign', 'EQ', item))
              })
            } else {
              this.handleSignFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let handleSign = params.row.handleSign
            if (handleSign == 1) {
              return h('label', '未处理未支付')
            } else if (handleSign == 2) {
              return h('label', '已处理未支付')
            } else if (handleSign == 3) {
              return h('label', '已处理已支付')
            }
          }
        },
        {
          title: '处理编号',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'handleNum',
          width: 160
        },
        {
          title: '在线处理',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'onlineHandle',
          width: 160,
          filters: [
            { label: '可以处理', value: 1 },
            { label: '不支持处理', value: 2 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.onlineHandleFilter = []
              val.forEach(item => {
                this.onlineHandleFilter.push(genQueryParam('onlineHandle', 'EQ', item))
              })
            } else {
              this.onlineHandleFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let onlineHandle = params.row.onlineHandle
            if (onlineHandle == 1) {
              return h('label', '可以处理')
            } else if (onlineHandle == 2) {
              return h('label', '不支持处理')
            }
          }
        }
        // {
        //   title: '操作',
        //   resizable: true,
        //   key: 'action',
        //   align: 'left',
        //   ellipsis: 'true',
        //   fixed: 'right',
        //   width: 180,
        //   render: (h, params) => {
        //     return h('div', [
        //       h('Button', {
        //         props: {
        //           type: 'primary',
        //           size: 'small',
        //           disabled: false
        //         },
        //         style: {
        //           marginRight: '5px'
        //         },
        //         on: {
        //           click: () => {
        //             this.vehicleInfoDetailId = params.row.transportVehicleInfoId
        //             this.vehicleInfoDetailModal = true
        //           }
        //         }
        //       }, '车辆信息'),
        //       h('Button', {
        //         props: {
        //           type: 'primary',
        //           size: 'small',
        //           disabled: false
        //         },
        //         style: {
        //           marginRight: '5px'
        //         },
        //         on: {
        //           click: () => {
        //             this.processPeccancyRecordId = params.row.id
        //             this.processPeccancyRecordModal = true
        //           }
        //         }
        //       }, '处理'),
        //       h('Button', {
        //         props: {
        //           type: 'primary',
        //           size: 'small',
        //           disabled: false
        //         },
        //         style: {
        //           marginRight: '5px'
        //         },
        //         on: {
        //           click: () => {
        //             this.$Modal.confirm({
        //               title: '提示',
        //               content: '<p>确认作废</p>',
        //               onOk: () => {
        //                 store.dispatch('PeccancyRecordServ_Cancel', {
        //                   params: { id: params.row.id }
        //                 }).then(() => {
        //                   this.$Message.success('作废成功')
        //                   this.onModifySuccess()
        //                 }).catch(err => {
        //                   this.$Message.error(err)
        //                 })
        //               },
        //               onCancel: () => {
        //
        //               }
        //             })
        //           }
        //         }
        //       }, '作废')
        //     ])
        //   }
        // }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'TransportVehicleInfoServ_GetPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage()
    },
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '跟进业务员') {
          this.columns[i].filters = this.marketsales
          break
        }
        if (this.columns[i].title === '车辆所有人') {
          this.columns[i].filters = this.allVehicleOwnerInfos
          break
        }
      }
    },
    onFilterClick () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let qo5 = null
      let qo6 = null
      let qo7 = null

      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('updateDatetime', false)
      }

      if (this.onlineHandleFilter) {
        qo5 = this.onlineHandleFilter
      }

      if (this.handleSignFilter) {
        qo6 = this.handleSignFilter
      }

      store.dispatch('PeccancyRecordServ_ClientGetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo5: qo5,
          qo6: qo6,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        if (store.getters.get_PeccancyRecord_ClientGetPageResult) {
          this.totalElements = store.getters.get_PeccancyRecord_ClientGetPageResult.totalElements
          this.content = store.getters.get_PeccancyRecord_ClientGetPageResult.content
          this.pageSize = store.getters.get_PeccancyRecord_ClientGetPageResult.size
        } else {
          this.totalElements = 0
          this.content = []
          this.pageSize = 0
        }
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage () {
      this.setPage(this.pageIndex)
    }
  },
  mounted () {
    this.$nextTick(() => {
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [7] }
      }).then(() => {
        let marketsales = store.getters.get_User_GetAllUsersResult
        this.marketsales = marketsales.map(item => {
          return { label: item.realName, value: item.id }
        })
        // this.columns[4].filters = this.installers
        // this.columns[13].filters = this.marketsales
        store.dispatch('VehicleOwnerInfoServ_ClientGetPage', {
          params: null,
          urlparams: null
        }).then(() => {
          let allVehicleOwnerInfos = store.getters.get_VehicleOwnerInfo_ClientGetPageResult.content
          this.allVehicleOwnerInfos = []
          allVehicleOwnerInfos.forEach(item => {
            this.allVehicleOwnerInfos.push({ label: item.shortName, value: item.id })
          })
          this.onColumnUpdate()
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
